import type { MultiHistoricalPortfolioContextValue } from './MultiHistoricalPortfolioContext';

export const countErrors = (errors: MultiHistoricalPortfolioContextValue['errors']): number =>
  Object.keys(errors).length;
